/*rutas del layout y dashboard*/
import DashboardBilling from '@/apps/billing/views/Dashboard.vue';
export default [
  {
    path: '',
    name: 'Billing',
    folder: DashboardBilling,
  }
];
